
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import { CentroCusto } from '../models/centrocusto.model';
import { CentroCustoDetalhes } from '../models/centroCustoDetalhes.model';
import { Observable } from 'rxjs';


@Injectable({providedIn: 'root'})
export class CentroCustoService {

    constructor(private http: HttpClient, private account: AccountService) { }

    private url = SCAMP_API.accountApiV1;

    getCentrosCustos(): Observable<CentroCusto[]> {

        return this.http.get<CentroCusto[]>(`${SCAMP_API.accountApiV1}/centroscustos`, { headers: this.account.composeHeaders() });
    }

    getCentrosCustosx(): Promise<CentroCusto[]> {
        
        return fetch(`${this.url}/centroscustos`, {
            headers: {
                "Authorization": this.account.composeHeaders().keys["Authorization"]
            }
        })
        .then(res => res.json());

        //return this.http.get<CentroCusto[]>(`${SCAMP_API.accountApiV1}/centroscustos`, { headers: this.account.composeHeaders() });
    }

    getCentroCustoDetalhes(id: number): Observable<CentroCustoDetalhes> {
        return this.http.get<CentroCustoDetalhes>(
            `${SCAMP_API.accountApiV1}/centrocustodetalhes/${id}`,
            { headers: this.account.composeHeaders() }
        );
    }

    get(id: number): Observable<CentroCusto> {
        return this.http.get<CentroCusto>(`${SCAMP_API.accountApiV1}/centrocustos/${id}`,
            { headers: this.account.composeHeaders() });
    }

    isUniqueCentroCusto(nome: string): Observable<boolean> {
        return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/centrocustos/is-unique`, {nome},
            { headers: this.account.composeHeaders() });
    }

    post(data: CentroCusto) {
        return this.http.post(`${SCAMP_API.accountApiV1}/centrocustos`, data,
            { headers: this.account.composeHeaders() });
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/centrocustos/${id}`,
            { headers: this.account.composeHeaders() });
    }

    list(): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/centroscustos`, { headers: this.account.composeHeaders() });
    }


}
